import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnnouncementService } from '../../../services/announcement.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
})
export class FooterComponent implements OnInit, OnDestroy {
  feedbackToolEnabled = false;
  currentYear = new Date().getFullYear();
  private phFrameObserver: MutationObserver | null = null;

  constructor(private announcementService: AnnouncementService) {}

  ngOnInit(): void {
    // Read persisted state from localStorage
    const stored = localStorage.getItem('ph-toolbar-enabled');
    this.feedbackToolEnabled = stored === null ? false : stored === 'true';
    // Set checkbox state on load (for direct DOM sync)
    setTimeout(() => {
      const cb = document.getElementById(
        'ph-toolbar-toggle'
      ) as HTMLInputElement;
      if (cb) cb.checked = this.feedbackToolEnabled;
      this.setFeedbackToolVisibility(this.feedbackToolEnabled);
      this.observePHFrame();
    });
  }

  ngOnDestroy(): void {
    if (this.phFrameObserver) {
      this.phFrameObserver.disconnect();
      this.phFrameObserver = null;
    }
  }

  observePHFrame() {
    // Watch for #_PH_frame being added to the DOM
    if (this.phFrameObserver) {
      this.phFrameObserver.disconnect();
    }
    this.phFrameObserver = new MutationObserver(() => {
      this.setFeedbackToolVisibility(this.feedbackToolEnabled);
    });
    this.phFrameObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  setFeedbackToolVisibility(show: boolean) {
    const phContainer = document.getElementById('_projecthuddle-container');
    if (phContainer)
      (phContainer as HTMLElement).style.display = show ? '' : 'none';
  }

  onFeedbackToolToggle(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.feedbackToolEnabled = checked;
    localStorage.setItem('ph-toolbar-enabled', checked ? 'true' : 'false');
    this.setFeedbackToolVisibility(checked);
  }

  openReleaseNotes() {
    console.debug('Release Notes link clicked');
    this.announcementService.openModal();
  }
}
